import { render, staticRenderFns } from "./LabelValueComponent.vue?vue&type=template&id=00b8bc64&"
import script from "./LabelValueComponent.vue?vue&type=script&lang=js&"
export * from "./LabelValueComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports